import { lt } from '@mews/framework';
import { useDialogForm } from '@mews-commander/form';
import { DataTestId } from '@mews-commander/enums';
import { CreateCancellationPolicyFormContent } from './CancellationPolicyFormContent';

export const useCreateCancellationPolicyDialogForm = () =>
    useDialogForm({
        id: 'create-cancellation-policy',
        title: lt('CancellationPolicyNew'),
        saveLabel: lt('Create'),
        submitButtonDataTestId: DataTestId.CreateCancellationPolicy,
        renderForm: (props) => <CreateCancellationPolicyFormContent {...props} />,
    });
